/* eslint-disable no-useless-catch */
import { entityService } from './services';

const pathname = '/product-unit-postfixes';

export const ProductUnitPostfixApi = {
  findMasterData: async () => {
    const url = `${pathname}/master-data`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};
